import React from 'react';
import './Footer.css';
import { config } from '../config';

interface FooterProps {
  darkMode?: boolean;
}

const Footer: React.FC<FooterProps> = ({ darkMode }) => {
  return (
    <footer className={`app-footer ${darkMode ? 'dark-mode' : ''}`}>
      <p>&copy; {new Date().getFullYear()} RSTLNE Game</p>
      {config.isProduction && <p className="version-info">Version {config.appVersion}</p>}
    </footer>
  );
};

export default Footer;
